import type { OfflineSummary } from './claim';
import type { OfflineGains } from '../sim/offline';

export interface ClaimPayload {
  alreadyClaimed?: boolean;
  gold?: number;
  xp?: number;
  dust?: number;
  dropRolls?: number;
  levelsGained?: number;
  elapsedSeconds?: number;
  effectiveSeconds?: number;
  farmStageId?: number;
  stagesPushed?: number;
  capped?: boolean;
}

/** Uses the server's numbers. Stage pushes from a claim are ignored. */
export function summaryFromClaim(claim: ClaimPayload): OfflineSummary | null {
  if (claim.alreadyClaimed) return null;
  const gold = num(claim.gold);
  const xp = num(claim.xp);
  const dust = num(claim.dust);
  const dropRolls = num(claim.dropRolls);
  const levelsGained = num(claim.levelsGained);
  if (gold === 0 && xp === 0 && dust === 0 && dropRolls === 0 && levelsGained === 0) return null;
  const elapsedMs = Math.round(num(claim.elapsedSeconds) * 1000);
  const effectiveMs = Math.round(num(claim.effectiveSeconds) * 1000);
  const gains: OfflineGains = {
    elapsedMs,
    rawElapsedMs: elapsedMs,
    effectiveMs,
    capped: claim.capped === true,
    gold,
    xp,
    dust,
    dropRolls,
    items: [],
    pity: { epicPlusSinceLegendary: 0 },
    farmStageId: num(claim.farmStageId),
    stagesPushed: 0,
  };
  return {
    gains,
    levelsGained,
    keptItems: [],
    salvaged: 0,
    dustGained: dust,
    goldGained: gold,
    xpGained: xp,
  };
}

function num(value: number | undefined): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}
